import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const servicesLinks = [
  'iOS Development',
  'Android Development',
  'Cross-Platform Apps',
  'UI/UX Design',
  'App Strategy',
  'Maintenance & Support',
];

const quickLinks = [
  { label: 'Home', to: '/' },
  { label: 'Services', to: '/services' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
];

function LinkList({ title, links, clickable = true }) {
  return (
    <div className="footer-column">
      <h2 className="footer-column__title">{title}</h2>
      <ul className="footer-list">
        {links.map((link) => {
          const label = typeof link === 'string' ? link : link.label;
          const to = typeof link === 'string' ? null : link.to;

          return (
            <li key={label}>
              {clickable && to ? (
                <Link className="footer-link" to={to}>
                  {label}
                </Link>
              ) : (
                <span className="footer-list__text">{label}</span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

function Footer() {
  const footerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const footerElement = footerRef.current;

    if (!footerElement) {
      return undefined;
    }

    if (!('IntersectionObserver' in window)) {
      setIsVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.18 },
    );

    observer.observe(footerElement);

    return () => observer.disconnect();
  }, []);

  return (
    <footer ref={footerRef} className={`site-footer ${isVisible ? 'site-footer--visible' : ''}`}>
      <div className="site-footer__inner">
        <div className="site-footer__grid">
          <section className="footer-brand" aria-labelledby="footer-brand-title">
            <Link className="brand-mark brand-mark--footer" to="/" aria-label="Milestor home">
              <span className="brand-mark__icon" aria-hidden="true">
                <span />
              </span>
              <span id="footer-brand-title" className="brand-mark__name">
                Milestor
              </span>
            </Link>
            <p className="footer-brand__tagline">We build apps that define the future.</p>
            <p className="footer-brand__text">
              Milestor partners with ambitious teams to design, engineer, and scale mobile products
              with the precision of a premium technology studio.
            </p>
            <span className="footer-brand__accent" aria-hidden="true" />
          </section>

          <LinkList title="Services" links={servicesLinks} clickable={false} />
          <LinkList title="Quick Links" links={quickLinks} />
        </div>

        <div className="footer-bottom">
          <p>© 2025 Milestor. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
